import { ReadPage } from '@tinct/core-api-models';
import { ApiError, tinctApi } from '../../api';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { GetQueryByIdParams } from '../../types';

export const getPageById = async (
  params: GetQueryByIdParams<ReadPage>,
): Promise<ReadPage> => {
  return await tinctApi.pages.getPageById(params);
};

export const useGetPageById = (
  params: GetQueryByIdParams<ReadPage>,
  options?: Omit<UseQueryOptions<ReadPage, ApiError>, 'queryKey'>,
) =>
  useQuery({
    queryKey: ['pages', params.id, params.fields],
    queryFn: () => getPageById(params),
    ...options,
  });
